import type { CommentCheckboxGroupProps, CustomCheckboxProps } from './data';

import React from 'react';
import { chakra } from '@chakra-ui/react';

import { Stack, Text } from '@/components';
import { useCheckbox, useCheckboxGroup } from '@/hooks';

const CommentCheckboxGroup = React.forwardRef<
  HTMLInputElement,
  CommentCheckboxGroupProps
>(({ data, checkedColor }, forwardedRef) => {
  function CustomCheckbox(props: CustomCheckboxProps) {
    const { state, getCheckboxProps, getInputProps, htmlProps } =
      useCheckbox(props);

    return (
      <chakra.label
        border="1px solid"
        borderColor={state.isChecked ? checkedColor : 'gray.800'}
        rounded="curved"
        px="22px"
        display="inline-block"
        py={2}
        cursor="pointer"
        maxW="max-content"
        {...htmlProps}
      >
        <input {...getInputProps()} hidden ref={props.innerRef} />
        <Text
          {...getCheckboxProps}
          fontSize={{ base: 'xs', md: 'sm' }}
          color={state.isChecked ? checkedColor : 'gray.800'}
        >
          {props.label}
        </Text>
      </chakra.label>
    );
  }

  const { getCheckboxProps } = useCheckboxGroup();

  return (
    <Stack
      direction="row"
      rowGap={{ base: '2', md: '26px' }}
      columnGap={{ base: '2', md: '18px' }}
      flexWrap="wrap"
      align="center"
      justify="center"
    >
      {data.map((item) => (
        <CustomCheckbox
          key={item.value}
          {...getCheckboxProps({ value: item.value })}
          innerRef={forwardedRef}
          label={item.label}
        />
      ))}
    </Stack>
  );
});

CommentCheckboxGroup.displayName = 'CommentCheckboxGroup';
export default CommentCheckboxGroup;
